import { render, staticRenderFns } from "./pro_hazards_table.vue?vue&type=template&id=d18c4cdc&scoped=true&lang=pug&"
import script from "./pro_hazards_table.vue?vue&type=script&lang=coffee&"
export * from "./pro_hazards_table.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18c4cdc",
  null
  
)

export default component.exports